"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParams = exports.getFilteredEventOccurrences = exports.getDefaultValues = exports.getDefaultFiltersValue = exports.getDefaultFiltersItemsValue = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextInput = _interopRequireDefault(require("../../TextInput/TextInput"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/search/24.js"));
var _MultiselectDropdownClient = require("./MultiselectDropdownClient");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-agenda {\n  padding-inline: 0px; }\n  .sia-agenda .bx--list-box__menu {\n    visibility: visible !important; }\n  .sia-agenda .filter-container {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    column-gap: 16px;\n    row-gap: 0px; }\n  .sia-agenda .sort-container {\n    display: flex;\n    justify-content: center; }\n    .sia-agenda .sort-container .sort {\n      width: max-content;\n      margin-bottom: 1rem; }\n      .sia-agenda .sort-container .sort label {\n        color: #a8a8a8; }\n  .sia-agenda .name-search {\n    position: relative; }\n    .sia-agenda .name-search svg {\n      position: absolute;\n      right: 8px;\n      top: 32px;\n      cursor: pointer; }\n    .sia-agenda .name-search label {\n      opacity: 0; }\n    .sia-agenda .name-search input {\n      padding-right: 42px; }\n\n@media (max-width: 66rem) {\n  .sia-agenda {\n    padding-inline: 16px; }\n    .sia-agenda .filter-container {\n      grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n\n@media (max-width: 42rem) {\n  .sia-agenda .filter-container {\n    grid-template-columns: repeat(1, minmax(0, 1fr)); } }\n";
  const fileName = "Filters_SIAAgenda";
  const element = document.querySelector("style[data-sass-component='Filters_SIAAgenda']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const defaultFilterMethod = (item, filter, filters) => filters[filter.name].includes(item[filter.value]);
const FILTERS = [{
  label: 'cms.agenda.organisator',
  name: 'organisators',
  value: 'organisator',
  filterMethod: (item, filter, filters) => {
    return filters['organisators'].find(t => t == item['organisator']?.id);
  }
}, {
  label: 'cms.agenda.themes',
  name: 'themes',
  value: 'theme',
  filterMethod: (item, filter, filters) => {
    return item['theme']?.find(theme => filters['themes'].find(el => el == theme.id));
  }
}, {
  label: 'cms.agenda.months',
  name: 'months',
  value: 'month',
  filterMethod: (item, filter, filters) => {
    return filters['months'].find(t => t == item['month']?.id);
  }
}, {
  label: 'cms.agenda.partners',
  name: 'partners',
  value: 'partner',
  filterMethod: (item, filter, filters) => {
    return filters['partners'].find(t => t == item['partner']?.id);
  }
}, {
  label: 'cms.agenda.types',
  name: 'types',
  value: 'type',
  filterMethod: (item, filter, filters) => {
    return filters['types'].find(t => t == item['type']?.id);
  }
}, {
  label: 'cms.agenda.locations',
  name: 'locations',
  value: 'locations',
  filterMethod: (item, filter, filters) => {
    return item[filter.value]?.find(location => filters[filter.name].includes(location.id));
  }
}, {
  label: 'cms.agenda.languages',
  name: 'languages',
  value: 'languages',
  filterMethod: (item, filter, filters) => {
    return item[filter.value]?.find(language => filters[filter.name].includes(language.id));
  }
}, {
  label: 'cms.agenda.content_type',
  name: 'content_types',
  value: 'content_type',
  hidden: true
}];
const getFilteredEventOccurrences = (event_occurrences, filters, name) => {
  let newValue = event_occurrences;
  if (name?.length > 0) {
    newValue = newValue.filter(item => item.name?.toLocaleLowerCase().includes(name?.toLocaleLowerCase()));
  }
  FILTERS.forEach(filter => {
    if (filters[filter.name]?.length > 0) {
      newValue = newValue.filter(item => filter?.filterMethod ? filter?.filterMethod(item, filter, filters) : defaultFilterMethod(item, filter, filters));
    }
  });
  return newValue;
};
exports.getFilteredEventOccurrences = getFilteredEventOccurrences;
const getUrlParams = (filters, name) => {
  const res = FILTERS.reduce((acc, curr) => {
    if (filters[curr.name]?.length > 0) {
      return acc[curr.name] = filters[curr.name].join(','), acc;
    } else {
      return acc;
    }
  }, {});
  return new URLSearchParams({
    ...res,
    ...(name ? {
      name: name
    } : {})
  });
};
exports.getUrlParams = getUrlParams;
const getDefaultValues = query => {
  const res = FILTERS.reduce((acc, curr) => (acc[curr.name] = query.get(curr.name)?.split(',') || [], acc), {});
  return {
    name: query.get('name') || '',
    ...res
  };
};
exports.getDefaultValues = getDefaultValues;
const getDefaultFiltersValue = defaultValues => {
  const res = FILTERS.reduce((acc, curr) => {
    return acc[curr.name] = defaultValues[curr.name]?.length > 0 ? defaultValues[curr.name] : undefined, acc;
  }, {});
  return res;
};
exports.getDefaultFiltersValue = getDefaultFiltersValue;
const getDefaultFiltersItemsValue = data => {
  const res = FILTERS.reduce((acc, curr) => (acc[curr.name] = data[curr.name], acc), {});
  return res;
};
exports.getDefaultFiltersItemsValue = getDefaultFiltersItemsValue;
const Filters = _ref => {
  let {
    defaultValues,
    translate,
    filters,
    filterItems,
    filteredEventsOccurrence,
    setFilters,
    setName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-container sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "name-search"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    defaultValue: defaultValues.name,
    id: 'name',
    label: 'name',
    name: 'name',
    onChange: event => {
      setName(event.target.value);
    },
    placeholder: translate('cms.agenda.name'),
    onKeyDown: e => {
      if (e?.key === 'Tab') {
        e.preventDefault();
        document.getElementById(FILTERS[0].name)?.querySelector('button')?.focus();
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: () => null
  })), FILTERS.map((filter, i) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: filter.name,
      style: {
        display: filter.hidden ? 'none' : 'block'
      }
    }, /*#__PURE__*/_react.default.createElement(_MultiselectDropdownClient.MultiselectDropdownClient, {
      key: filter.name,
      id: filter.name,
      label: translate(filter.label),
      items: filterItems[filter.name] || [],
      values: filters[filter.name],
      setValues: values => {
        setFilters({
          ...filters,
          [filter.name]: values
        });
      },
      activeItems: filteredEventsOccurrence.map(eventOccurrence => eventOccurrence[filter.value]).flat(),
      onKeyDown: e => {
        if (i + 1 >= FILTERS.length) return;
        if (e?.key === 'Tab') {
          e.preventDefault();
          document.getElementById(FILTERS[i + 1].name)?.querySelector('button')?.focus();
        }
      },
      ignoreSort: filter.name === 'months'
    }));
  }));
};
var _default = exports.default = Filters;